export const exploreHeads = [
  "Application Banners",
  "Featured Apps",
  "Try something new",
  "People are Loving"
];
